import { authQueries } from 'src/api/queries';

export const requestQueryKey = {
  index: (...args: any[]) => [authQueries.requests, ...(args ?? [])],
  self: (id: string, ...args: any[]) => [authQueries.request, id, ...(args ?? [])],
};
